import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const companyRedirectGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const session = auth.getSession();
  if (!session?.id_cia) return true;
  const encoded = btoa(String(session.id_cia));
  return router.parseUrl(`/dashboard/${encoded}`);
};
